import { ConfigurationLevelDto } from "./ConfigurationLevelDto";

export class UpdateConfigurationByLevelsDto {
    constructor(public Levels: ConfigurationLevelDto[], public ConfigurationId: number) {
    }
}